import { ReactElement, useState } from "react";
import { ContactType } from "../../../../lib/filters/dto";
import { useAppDispatch } from "../../../../lib/redux/hooks";
import { useCsvImport } from "../../../../lib/useCsvImport";
import { ImportModalContacts } from "../../../database/commons/import/modal";
import { ImportCSVResponseDTO } from "../../../database/dto";
import { TargetListPageEnum } from "../../dto";
import { setTargetListPage } from "../../slice";
import { AssociateCompaniesForCSV } from "./associateCompanies";
import { AssociatePeopleForCSV } from "./associatePeople";
import { UploadFileForCSV } from "./uploadFile";

interface Props {
  contactType: ContactType
  targetListId: string
}

export function ImportFromCSV(props: Props) {
  const { contactType, targetListId } = props
  const [step, setStep] = useState<number>(0);
  const [name, setName] = useState("");
  const [delimiter, setDelimiter] = useState("");
  const [fields, setFields] = useState<string[]>([]);
  const [file, setFile] = useState<File | null>(null);
  const [rows, setRows] = useState<Record<string, any>[]>([]);
  const [importResponse, setImportResponse] = useState<ImportCSVResponseDTO | undefined>();
  const [showModal, setShowModal] = useState(false);

  const dispatch = useAppDispatch();

  const resetFileState = () => {
    setName("");
    setDelimiter("");
    setFields([]);
    setRows([]);
    setFile(null);
  };

  const { handleFileChange } = useCsvImport(
    resetFileState,
    setName,
    setDelimiter,
    setFields,
    setRows,
    setFile
  )

  const csvStepMap = new Map<number, ReactElement>([
    [
      0,
      <UploadFileForCSV
        step={step}
        setStep={function (value: number): void {
          setStep(value);
        }}
        handleChange={function (e: File[]): void {
          handleFileChange(e);
        }}
        file={file}
      />,
    ],
    [
      1,
      contactType === ContactType.COMPANY ?
        <AssociateCompaniesForCSV
          targetListId={targetListId}
          step={step}
          setStep={(e) => setStep(e)}
          name={name}
          delimiter={delimiter}
          fields={fields}
          file={file}
          rows={rows}
          onImportSuccess={(response) => {
            setImportResponse(response);
            setShowModal(true);
          }}
          onImportError={() => {
            setShowModal(true);
          }}
        /> :
        <AssociatePeopleForCSV
          targetListId={targetListId}
          step={step}
          setStep={(e) => setStep(e)}
          name={name}
          delimiter={delimiter}
          fields={fields}
          file={file}
          rows={rows}
          onImportSuccess={(response) => {
            setImportResponse(response);
            setShowModal(true);
          }}
          onImportError={() => {
            setShowModal(true);
          }}
        />,
    ],
  ]);
  return <>
    {csvStepMap.get(step)}
    <ImportModalContacts
      importResponse={importResponse}
      showModal={showModal}
      onClose={() => {
        setShowModal(false);
        setImportResponse(undefined);
        dispatch(setTargetListPage(TargetListPageEnum.LIST));
      }}
    />
  </>;
}
